define('user-agent',['require','exports','module','ua-parser'],function(require, exports, module) {

    var uaParser = require('ua-parser');

    /**
     * @typedef {object} BrowserInfo
     *
     * @property {string} name
     * @property {string} version
     * @property {string} major
     * @property {string} simpleName
     * @property {boolean} isChrome
     * @property {boolean} isFirefox
     * @property {boolean} isIE
     * @property {boolean} isOpera
     * @property {boolean} isSafari
     * @property {boolean} isOther
     */

    var browserMatchers = [
        {name: 'Chrome', regex: /chrome|chromium/i},
        {name: 'Firefox', regex: /firefox|fennec/i},
        {name: 'IE', regex: /(ie|avant)/i},
        {name: 'Opera', regex: /opera/i},
        {name: 'Safari', regex: /safari/i},
        {name: 'Other', regex: /.*/} // catch-all, need to be last element in array
    ];

    /**
     * @typedef {object} OSInfo
     *
     * @property {string} name
     * @property {string} version
     * @property {string} simpleName
     * @property {string} fullName
     */

    var osMatchers = [
        {name: 'android', regex: /android/i},
        {name: 'ios', regex: /(ipad|iphone|ipod|ios)/i},
        {name: 'mac', regex: /mac os/i},
        {name: 'windows', regex: /windows/i},
        {name: 'other', regex: /.*/} // catch-all, need to be last element in array
    ];

    /**
     * @typedef {object} UserAgentInfo
     *
     * @property {Array.<string>} browsers - All possible values of #browser.simpleName
     * @property {BrowserInfo} browser
     * @property {OSInfo} os
     */

    /**
     * @typedef {object} UserAgentMatcher
     *
     * @property {string} name
     * @property {RegExp} regex
     *
     * @private
     */

    /**
     * Returns the name property of the first Matcher matching needle.
     *
     * @param {string} needle
     * @param {Array.<UserAgentMatcher>} matchers
     * @returns {string}
     */
    function match(needle, matchers) {
        return matchers.reduce(function(prev, curr) {
            if (!prev && curr.regex.test(needle)) {
                return curr.name.toLowerCase();
            }
            return prev;
        }, '');
    }

    /**
     * @function UserAgent
     *
     * @param {string} uaString - The user agent string to be parsed
     *
     * @returns {UserAgentInfo}
     */
    function UserAgent(uaString) {
        var UA = Object.create(uaParser(uaString));

        UA.browsers = browserMatchers.map(function(browser) {
            return browser.name;
        });

        // run UA.browserName against all BrowserInfo matchers to determine simple name
        UA.browser.simpleName = match(UA.browser.name, browserMatchers);

        UA.browser.versionedName = [UA.browser.name, UA.browser.version].join(' ').trim();

        // Set "browser.isChrome (isFirefox, isSafari, etc.)" values
        browserMatchers.forEach(function(browser) {
            UA.browser['is' + browser.name] = UA.browser.simpleName == browser.name.toLowerCase();
        });

        UA.os.simpleName = match(UA.os.name, osMatchers);

        // ua-parser classifies certain older Mobile Safari as MacOS
        if (UA.os.simpleName == 'mac' && UA.device.type == 'mobile') {
            UA.os.simpleName = 'ios';
        }

        UA.os.fullName = [UA.os.name, UA.os.version].join(' ').trim();

        return UA;
    }

    module.exports = UserAgent;
});

